import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconReviewTodo = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "34px",
	height: "21px",
	viewBox: "0 0 34 21",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "Group 8"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "\\xDCbersicht-Neue-Satzproben",
			transform: "translate(-24.000000, -144.000000)",
			stroke: "#FFFFFF",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group-8",
				transform: "translate(25.000000, 144.000000)",
				children: [
					/* @__PURE__ */ _jsx("line", {
						x1: 15.2666667,
						y1: 4.25,
						x2: 31,
						y2: 4.5,
						id: "Line-5",
						strokeWidth: 4,
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("line", {
						x1: 15.2666667,
						y1: 15.25,
						x2: 31,
						y2: 15.5,
						id: "Line-5-Copy",
						strokeWidth: 4,
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle",
						strokeWidth: 2,
						x: 1,
						y: 1,
						width: 7,
						height: 7
					}),
					/* @__PURE__ */ _jsx("polyline", {
						id: "Path-4",
						strokeWidth: 3,
						strokeLinecap: "round",
						points: "1 15.8722027 3.95302958 18 7.66666667 13"
					})
				]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconReviewTodo);
export { ForwardRef as ReactComponent };
